//import projects
import Template from './Template';
import prompts from '../../../dummy_data/prompt_engineer/foreign_language.json';
// External variant
const options = ['Dịch thuật', 'Kinh nghiệm học ngoại ngữ', 'Sửa bài tập ngoại ngữ', 'Khám phá ngôn ngữ mới'];

const prompt_persona_role =
    'Phản hồi như một người thông thạo nhiều ngôn ngữ, hướng dẫn tôi khám phá và thành thạo các ngôn ngữ khác nhau.';

export default function ForeignLanguage() {
    return (
        <Template
            personaRole={prompt_persona_role}
            data={prompts}
            title="Ngoại ngữ"
            options={options}
            project="prompt_engineer/foreign_language"
        />
    );
}
